<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="10"
        offset-md="1"
        lg="10"
        offset-lg="1"
        xl="10"
        offset-xl="1"
      >
        <template v-if="showSkeleton">
          <v-skeleton-loader
            class="mb-6"
            type="card-avatar, article, list-item-avatar, list-item-avatar"
          ></v-skeleton-loader>
        </template>
        <template v-if="!showSkeleton && courses != null">
          <v-row class="pt-5">
            <v-col cols="12">
              <div class="contentHeader">My Favorite</div>
            </v-col>
          </v-row>

          <v-row>
            <template v-for="item of courses">
              <v-col
                cols="12"
                sm="6"
                lg="4"
                xl="3"
                class="pr-5"
                :key="`course_${item._id}`"
              >
                <v-hover v-slot:default="{ hover }">
                  <v-card
                    class="recCourseCustomCard hoverable card-growable"
                    elevation="0"
                    ripple=""
                    @click="navigate(item)"
                  >
                    <v-img
                      class="recCourseImage"
                      max-width="100%"
                      width="auto"
                      :src="item.image"
                    >
                    </v-img>
                    <v-row>
                      <v-col>
                        <div
                          :style="{
                            color: `${$themeColor}`,
                            fontSize: `13px`,
                            fontWeight: `500`,
                            marginTop: `8px`,
                            marginBottom: `8px`,
                          }"
                          v-text="item.categories[0].title"
                        ></div>
                        <div class="myCourseTitle">{{ item.title }}</div>
                        <div class="recInstructor">
                          {{ item.owner_by_students[0]._id.displayName }}
                        </div>
                        <div class="d-flex" style="align-items: center">
                          <div>
                            <v-rating
                              half-increments
                              half-icon="fas fa-star-half-alt"
                              background-color="grey"
                              color="amber"
                              readonly
                              dense
                              small
                              :value="item.rating"
                            ></v-rating>
                          </div>
                          <div class="ml-2 flex-grow-1">
                            <p class="mt-1 mb-0 body-2">{{ item.rating }}</p>
                          </div>
                          <v-spacer></v-spacer>
                          <div class="ml-2 flex-grow-1 text-end">
                            <p
                              v-if="item.bundle.length"
                              class="mb-0 subtitle-1 font-weight-black"
                            >
                              ฿{{
                                item.bundle.length
                                  ? numberWithCommas(item.bundle[0].price)
                                  : 0
                              }}
                            </p>
                            <p v-else class="mb-0 subtitle-1 font-weight-black">
                              Free
                            </p>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-hover>
              </v-col>
            </template>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
function compare(a, b) {
  if (a.price < b.price) {
    return -1;
  }
  if (a.price > b.price) {
    return 1;
  }
  return 0;
}
export default {
  data: () => ({
    loading: false,
    courses: null,
    showSkeleton: true,
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fetch();
      this.fetchBundle();
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    fetchBundle() {
      var sortable = [];
      this.content.body.forEach((element) => {
        if (element.bundle.length) {
          sortable = element.bundle.sort(compare);
        } else {
          // no bundle
        }
      });
    },
    fetch() {
      this.profile = null;
      this.showSkeleton = true;
      this.$http
        .get(`${this.$store.state.api}/wishlist/user/course`)
        .then((resp) => {
          if (resp.data.status == true) {
            this.courses = resp.data.result;
          } else {
            this.courses = null;
          }
        })
        .catch((err) => {
          this.courses = null;
        })
        .finally(() => {
          this.showSkeleton = false;
        });
    },
    navigate(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: item._id,
        },
      });
    },
  },
};
</script>
<style scoped>
.contentHeader {
  font-size: 26px;
  font-weight: bold;
  color: #000000;
}

.recCourseCustomCard {
  /* border-radius: 4px; */
  border: solid 1px #dcdcdc;
  background-color: #ffffff;
  padding: 15px 15px 15px 15px;
}

.myCourseCatagory {
  font-size: 13px;
  font-weight: 500;
  color: #4a90e2;
  margin-top: 8px;
  margin-bottom: 8px;
}

.myCourseTitle {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  color: #4a4a4a;
  margin-bottom: 0px;

  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* min-height: 35px;
  max-height: 43px; */
}

.recCourseImage {
  width: 100%;
  height: 200px;
}

.recInstructor {
  font-size: 14px;
  line-height: 1.57;
  color: #9b9b9b;
  margin-top: 8px;
  margin-bottom: 8px;
}

.v-card > *:first-child:not(.v-btn):not(.v-chip) {
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}
</style>
